export class Instructions {
    private container: HTMLDivElement;
    private helpButton: HTMLButtonElement;
    private closeButton: HTMLButtonElement;
    private readonly INSTRUCTIONS_VIEWED_KEY = 'vibehoops_instructions_viewed';

    constructor() {
        this.createHelpButton();
        this.createInstructionsPopup();
        
        // Show instructions if first time
        if (!localStorage.getItem(this.INSTRUCTIONS_VIEWED_KEY)) {
            this.showInstructions();
        }
    }

    private createHelpButton(): void {
        this.helpButton = document.createElement('button');
        this.helpButton.innerHTML = '❔';
        
        // Apply styles directly
        this.helpButton = document.createElement('button');
        this.helpButton.style.position = 'fixed';
        this.helpButton.style.bottom = '20px';
        this.helpButton.style.left = '20px';
        this.helpButton.style.padding = '10px';
        this.helpButton.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        this.helpButton.style.border = 'none';
        this.helpButton.style.borderRadius = '5px';
        this.helpButton.style.cursor = 'pointer';
        this.helpButton.style.color = 'white';
        this.helpButton.style.fontSize = '20px';
        this.helpButton.style.zIndex = '1000';
        this.helpButton.style.width = '45px';
        this.helpButton.style.height = '45px';
        this.helpButton.style.display = 'flex';
        this.helpButton.style.alignItems = 'center';
        this.helpButton.style.justifyContent = 'center';

        // Set initial icon
        this.helpButton.innerHTML = '❔';

        this.helpButton.addEventListener('pointerdown', () => this.showInstructions());

        // Add hover effects
        this.helpButton.addEventListener('mouseenter', () => {
            this.helpButton.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        });
        this.helpButton.addEventListener('mouseleave', () => {
            this.helpButton.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        });

        document.body.appendChild(this.helpButton);
        
    }

    private createInstructionsPopup(): void {
        this.container = document.createElement('div');
        this.container.id = 'instructions-popup';
        this.container.style.position = 'absolute';        
        this.container.style.top = '20%';
        this.container.style.left = '50%';
        this.container.style.transform = 'translate(-50%, -20%)';
        this.container.style.background = 'rgba(0, 0, 0, 0.85)';
        this.container.style.color = 'white';
        this.container.style.borderRadius = '15px';
        this.container.style.maxWidth = '400px';
        this.container.style.minWidth = '340px';
        this.container.style.maxHeight = '90vh';
        this.container.style.display = 'none';
        this.container.style.fontFamily = 'system-ui, -apple-system, sans-serif';
        this.container.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';

        // Create header container
        const headerContainer = document.createElement('div');
        headerContainer.style.padding = '5px';
        headerContainer.style.position = 'relative';
        headerContainer.style.borderBottom = '1px solid rgba(255, 255, 255, 0.1)';

        // Create and style close button
        this.closeButton = document.createElement('button');
        this.closeButton.innerHTML = '✕';
        this.closeButton.style.position = 'absolute';
        this.closeButton.style.top = '0px';
        this.closeButton.style.right = '0px';
        this.closeButton.style.background = 'none';
        this.closeButton.style.border = 'none';
        this.closeButton.style.color = 'white';
        this.closeButton.style.fontSize = '24px';
        this.closeButton.style.cursor = 'pointer';
        this.closeButton.style.padding = '8px';
        this.closeButton.style.margin = '5px';
        this.closeButton.style.lineHeight = '1';
        this.closeButton.style.display = 'flex';
        this.closeButton.style.alignItems = 'center';
        this.closeButton.style.justifyContent = 'center';
        this.closeButton.style.width = '32px';
        this.closeButton.style.height = '32px';
        this.closeButton.style.borderRadius = '4px';
        this.closeButton.style.transition = 'background-color 0.2s';

        this.closeButton.addEventListener('pointerdown', () => this.hideInstructions());
        this.closeButton.addEventListener('mouseenter', () => {
            this.closeButton.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        });
        this.closeButton.addEventListener('mouseleave', () => {
            this.closeButton.style.backgroundColor = 'transparent';
        });

        const title = document.createElement('h2');
        title.textContent = 'How to Play 🏀';
        title.style.marginTop = '0';
        title.style.marginBottom = '0';
        title.style.fontSize = '20px';
        title.style.textAlign = 'center';

        headerContainer.appendChild(title);
        headerContainer.appendChild(this.closeButton);

        // Create scrollable content container
        const contentContainer = document.createElement('div');
        contentContainer.style.padding = '10px 20px';
        contentContainer.style.overflowY = 'auto';
        contentContainer.style.maxHeight = 'calc(90vh - 80px)'; // Subtract header height

        const instructions = document.createElement('div');
        instructions.innerHTML = `
            <div style="font-size: 16px; line-height: 1.6;">
                <p>🎮 <strong>Controls</strong></p>
                <ul style="padding-left: 20px;">
                    <li>👆 Click/tap and drag to move player</li>
                    <li>🎯 Tap backboard to shoot</li>
                    <li>🏃‍♂️ Tap another player to pass</li>
                </ul>
                <br/>
                <p>🏆 <strong>Scoring</strong></p>
                <ul style="padding-left: 20px;">
                    <li>2️⃣ points for shots inside the arc</li>
                    <li>3️⃣ points for shots outside the arc</li>
                </ul>
                <br/>
                <p>🎮 <strong>Game Rules</strong></p>
                <ul style="padding-left: 20px;">
                    <li>🏀 Defend backboard that matches your color</li>                    
                    <li>🎯 First team to 21 points wins!</li>
                    <li>🏆 Must win by 2 points</li>
                    <li>👥 "Invite" to play with friends</li>
                </ul>
            </div>
        `;

        contentContainer.appendChild(instructions);

        this.container.appendChild(headerContainer);
        this.container.appendChild(contentContainer);
        document.body.appendChild(this.container);
    }

    private showInstructions(): void {
        this.container.style.display = 'block';
        localStorage.setItem(this.INSTRUCTIONS_VIEWED_KEY, 'true');
    }

    private hideInstructions(): void {
        this.container.style.display = 'none';
    }

    public dispose(): void {
        if (this.container && this.container.parentNode) {
            this.container.parentNode.removeChild(this.container);
        }
        if (this.helpButton && this.helpButton.parentNode) {
            this.helpButton.parentNode.removeChild(this.helpButton);
        }
    }
} 